@if (sharedService.getUser() | async) {
  @if (sharedService.isUserCreditHold) {
    <app-credit-hold-message> </app-credit-hold-message>
  }
}

<div class="row mt-3">
  <div class="col-md-12 col-lg-6">
    <label>
      <span class="label-content">{{ 'checkoutPO.poNumber' | cxTranslate }}</span>
      <input
        #poNumber
        class="form-control"
        formControlName="poNumber"
        type="text"
        placeholder="{{ 'checkoutPO.placeholder' | cxTranslate }}"
        value="{{ cartPoNumber$ | async }}"
      />
    </label>
  </div>
</div>
<div class="row">
  <div class="col-md-12 col-lg-6">
    @if ((paymentTypes$ | async)?.length && typeSelected$ | async) {
      <label class="cx-payment-type-container">
        <span class="label-content">{{ 'paymentTypes.title' | cxTranslate }}</span>
        @for (type of paymentTypes$ | async; track type) {
          <div class="form-check">
            <input
              id="paymentType-{{ type.code }}"
              class="form-check-input"
              type="radio"
              aria-checked="true"
              (change)="changeType(type.code)"
              [value]="type.code"
              [checked]="true"
              formControlName="paymentType"
            />
            <label class="cx-payment-type-label form-check-label form-radio-label" for="paymentType-{{ type.code }}">
              <div class="cx-payment-type">
                {{ 'paymentTypes.paymentType' | cxTranslate: { context: type.code } }}
              </div>
            </label>
          </div>
        }
      </label>
    } @else {
      <div class="cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
    }
  </div>
</div>

<div class="cx-checkout-btns row">
  <div class="col-md-12 col-lg-6">
    <button class="btn btn-block btn-action" (click)="back()">
      {{ 'checkout.backToCart' | cxTranslate }}
    </button>
  </div>
  <div class="col-md-12 col-lg-6">
    <button [disabled]="sharedService.isUserCreditHold" class="btn btn-block btn-primary" (click)="next()">
      {{ 'common.continue' | cxTranslate }}
    </button>
  </div>
</div>
